import { Navigate, useLocation } from 'react-router-dom'

export default function Production() {
  const location = useLocation()
  return <Navigate to={`/analytics/financial${location.search}`} replace />
}
